export const BASE_URL = "https://api.sunrose.trangotechdevs.com";
// export const BASE_URL = "http://172.17.0.153:4000";
// export const BASE_URL = "https://webnew.convobird.com";
// export const BASE_URL = "https://web.convobird.com";
// export const BASE_URL = "http://172.16.109.116:4000";
